import { Box } from '@material-ui/core';
import React from 'react';

export default function ButtonContainer({ children, ...props }) {
  return <Box mt="2rem" {...props}>{children}</Box>;
}
